import { BASE_URL } from '../constants/api';
import Fetch from './fetch';
import { Emit, socket } from '../components/socket';
const baseUrl = `${BASE_URL}/api/api`;

export async function generateCapcha() {
  const url = `${baseUrl}/generateCapcha`;
  const json = await Fetch<{
    text: string;
  }>(url, {
    method: 'POST',
  });

  return {
    code: json.text,
    url: `${BASE_URL}/api/api/capcha?x=${json.text}`,
  };
}

export async function checkCapcha(code, input) {
  const url = `${baseUrl}/checkCaptcha?x=${code}&input=${input}`;
  const json = await Fetch<{
    data: boolean;
  }>(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return json;
}

export async function submitRegister(data) {
  return new Promise(resolve => {
    Emit('newRegisterCustomer', data, async response => {
      // console.log(45, response);
      if (response.data && response.data.status == 0) {
        resolve({ info: response.data.message || 'errored' });
      } else if (response.status == 0) {
        resolve({ info: response.message || 'errored' });
      }

      resolve(response.data);
    });
  });
}

export async function submitSecurityCodeActivation(data) {
  return new Promise(resolve => {
    Emit('inputSecurityActivationCode', data, async response => {
      resolve({ data: response });
    });
  });
}
